import React from 'react';
import Hero from './components/Hero';
import Experience from './components/Experience';
import Projects from './components/Projects';
import Skills from './components/Skills';
import Education from './components/Education';
import Interests from './components/Interests';
import Contact from './components/Contact';
import ThemeToggle from './components/ThemeToggle';
import LanguageToggle from './components/LanguageToggle';
import { LanguageProvider } from './context/LanguageContext';

function App() {
  return (
    <LanguageProvider>
      <main className="min-h-screen bg-base-100 text-base-content transition-colors duration-300">
        <ThemeToggle />
        <LanguageToggle />
        <div className="flex flex-col">
          <Hero />
          <Experience />
          <Projects />
          <Skills />
          <Education />
          <Interests />
          <Contact />
        </div>
      </main>
    </LanguageProvider>
  );
}

export default App; 